import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { Button, Stack, Typography } from '@mui/material';
import { OfficeService, getAuthToken } from '../../service';

import { AbsReactTable, TABLE } from 'customer_portal-ui-shared';
import OfficeEdit from './office-edit.component';
import OfficeDelete from './office-delete.component';

const OfficeList = () => {
    const { instance, accounts } = useMsal();
    const [isLoading, setIsLoading] = useState(true);

    const [offices, setOffices] = useState([]);

    const [pageData, setPageData] = useState([]);
    const tablePageOption = [20, 50, 80, 100];

    const tableColumnsOffice = [
        {
            label: (
                <>
                    <Button component="label" variant="contained" size="small" color="success" onClick={() => alert('Coming Soon!')}>
                        New
                    </Button>
                </>
            ),
            accessor: 'Action1',
            Cell: ({ cell: { value } }) => <OfficeEdit officeId={value} onPostSave={handlePostOfficeUpdate} />
        },
        {
            label: 'Name',
            accessor: 'Name'
        },
        {
            label: 'Division',
            accessor: 'Division'
        },
        {
            label: 'Country',
            accessor: 'Country'
        },
        {
            label: 'City',
            accessor: 'City'
        },
        {
            label: 'Address Line 1',
            accessor: 'AddressLine1'
        },
        {
            label: 'Address Line 2',
            accessor: 'AddressLine2'
        },
        {
            label: '',
            accessor: 'Action2',
            Cell: ({ cell: { value } }) => <OfficeDelete officeId={value} />
        }
    ];

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await getOffices();

            setIsLoading(false);
        })();
    }, []);

    const getOffices = async () => {
        const authToken = await getAuthToken(instance, accounts[0]);
        const data = await OfficeService.getAll(authToken);

        if (!data) {
            console.error('Error: Office Data.');
            return;
        }

        const tempOffices = data.map((office) => {
            office.Action1 = office.Id;
            office.Action2 = office.Id;

            return office;
        });

        setOffices(tempOffices);
        setPageData(tempOffices.slice(0, tablePageOption[0] * (0 + 1)));
    };

    const applyFilter = (filtersObj) => {
        const { pageIndex, pageSize } = filtersObj;
        const tempData = offices.slice(pageIndex * pageSize, pageSize * (pageIndex + 1));
        setPageData(tempData);
    };

    const handlePostOfficeUpdate = async () => {
        setIsLoading(true);
        await getOffices();

        setIsLoading(false);
    };

    return (
        <Stack direction={'column'} spacing={2} style={{ marginTop: '10px' }}>
            {isLoading ? (
                <Typography>Loading...</Typography>
            ) : (
                <AbsReactTable
                    tableType={TABLE.TYPE.BASIC}
                    columns={tableColumnsOffice}
                    data={pageData}
                    dataCount={offices.length}
                    pagination={true}
                    small={true}
                    allowColumnsShowHide={false}
                    applyFilterCallback={applyFilter}
                    pageOptions={tablePageOption}
                />
            )}
        </Stack>
    );
};

export default OfficeList;
